import { render } from "./RecursiveItem.vue?vue&type=template&id=1c1bb264&scoped=true"
import script from "./RecursiveItem.vue?vue&type=script&lang=js"
export * from "./RecursiveItem.vue?vue&type=script&lang=js"

import "./RecursiveItem.vue?vue&type=style&index=0&id=1c1bb264&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1bb264"]])

export default __exports__